import useSWR from "swr";
import { type OfficeData } from "../types";
import { simpleFetcher } from "../fetcher";
import { useLanguageContext } from "~/context/language";

interface Options {
  embed?: boolean;
}

export function useOfficeData(id?: number | string, options?: Options) {
  const { language } = useLanguageContext();

  const params = [`language=${language}`];
  if (options?.embed) params.push(`embed=${options.embed}`);

  const queryString = params.length > 0 ? `?${params.join("&")}` : "";
  const url = id ? `/wopi/files/${id}/data${queryString}` : null;

  const { data, error, isLoading, mutate } = useSWR<OfficeData, Error>(
    url,
    simpleFetcher,
    { revalidateOnFocus: false, revalidateOnMount: true },
  );

  return { data, error, mutate, isLoading };
}
